export function validate(value, requiredKeys, optionalKeys = []) {
    const passedKeys = Object.keys(value);
    const validKeys = [...requiredKeys, ...optionalKeys];
    const invalidKeys = passedKeys.filter((key) => !validKeys.includes(key));
    if (invalidKeys.length > 0) {
        throw new Error(`Invalid dependencies provided: ${invalidKeys}`);
    }
    for (const requiredKey of requiredKeys) {
        if (!passedKeys.includes(requiredKey)) {
            throw new Error(`Missing dependency: ${requiredKey}`);
        }
    }
}
function validateAppDeps(deps) {
    const requiredKeys = [
        'approveConnection',
        'approveMessage',
        'approveTransactions',
        'ensureTrusted',
        'isAutoApproved',
        'isTrusted',
        'getOrigin',
        'scanDomains',
    ];
    const optionalKeys = [
        'getAsset',
        'isDevelopmentEnvironment',
        'getIsConnected',
        'onTransactionsSigned',
        'getPathname',
        'ensureUntrusted',
    ];
    validate(deps, requiredKeys, optionalKeys);
}
function validateWalletDeps(deps) {
    const requiredKeys = [];
    const optionalKeys = ['ensureUnlocked', 'isUnlocked', 'reportMaliciousSite'];
    validate(deps, requiredKeys, optionalKeys);
}
export function validateCommonDeps(deps, otherOptionalKeys = []) {
    const requiredKeys = ['app'];
    const optionalKeys = ['wallet', ...otherOptionalKeys];
    validate(deps, requiredKeys, optionalKeys);
    const { app, wallet } = deps;
    validateAppDeps(app);
    if (wallet) {
        validateWalletDeps(wallet);
    }
}
